module.exports = __webpack_public_path__ + "img/success-icon.e1d600ce.png";